// @ts-nocheck

export type TenantGetWithOccupants = typeof TenantGetWithOccupants[keyof typeof TenantGetWithOccupants];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TenantGetWithOccupants = {
  true: 'true',
  false: 'false',
} as const;
